// extracted by mini-css-extract-plugin
module.exports = {"footer":"DigitalKeysBottomSheet_footer__vlivf"};